import { Logout } from '@mui/icons-material';
import { Box, List, ListItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { getRouteLogin } from 'shared/constants/routerConst';
import useAuth from 'shared/hooks/useAuth';
import { VersionInfo } from 'shared/ui/VersionInfo';

const listItemStyles = {
  sx: {
    p: 0,
    ':hover': {
      bgcolor: 'action.hover',
      cursor: 'pointer',
    },
  },
};

const listItemContentStyles = {
  width: '100%',
  height: '40px',
  display: 'flex',
  alignItems: 'center',
  p: '0 16px',
};

interface AccountMenuItemsProps {
  onClose?: () => void;
}

export const AccountMenuItems = ({ onClose }: AccountMenuItemsProps) => {
  const { t } = useTranslation();
  const { logout } = useAuth();
  const navigate = useNavigate();

  const onLogout = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onClose) {
      onClose();
    }
    logout();
    navigate(getRouteLogin());
  };

  return (
    <List
      sx={{
        padding: 0,
      }}
    >
      <ListItem {...listItemStyles} onClick={onLogout}>
        <Box {...listItemContentStyles}>
          <Logout sx={{ mr: 1, fontSize: 20 }} />
          <Typography variant="body2">{t('Sign Out')}</Typography>
        </Box>
      </ListItem>
      <Typography
        flex="1"
        align="right"
        style={{
          borderTop: '1px solid #e0e0e0',
          paddingTop: '8px',
          paddingRight: '10px',
          opacity: '0.5',
          fontSize: '12px',
        }}
        typography="openSans.caption"
      >
        <VersionInfo />
      </Typography>
    </List>
  );
};
